module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"holder_document":"Documento da conta bancária","holder_type_individual":"Pessoa física","holder_type_company":"Pessoa jurídica"},"en-US":{"holder_document":"Bank account document","holder_type_individual":"Individual","holder_type_company":"Company"}}')
  delete Component.options._Ctor
}
